import { invalidateMinicart } from "~/app/store/bffApi";
import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

export function resolveDeleteCartSectionUrl(activeCartId: string, quoteNumber?: string): string {
  const sectionPath = quoteNumber ? `/sections/quotes/${encodeURIComponent(quoteNumber)}` : "/sections/non-bundled";
  return occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}${sectionPath}`);
}

export async function apiDeleteCartSection(quoteNumber?: string): Promise<void> {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot delete Cart section without an explicit Active Cart identity");
  }
  return occFetch(resolveDeleteCartSectionUrl(activeCartId, quoteNumber), {
    method: "DELETE",
  })
    .then((res) => {
      if (!res.ok) {
        throw new Error("Error when clearing section");
      }
    })
    .then((result) => {
      invalidateMinicart();
      return result;
    });
}
